import { useParams } from 'react-router-dom';

import { EditCampaignProvider } from '@/contexts/edit-campaign-context';

import { OtherChannelsDialog } from './other-channels';
import { ReachCampaignPage } from './reach';

function EditCampaignContent() {
  const { channelSlug } = useParams();

  if (channelSlug) {
    return <OtherChannelsDialog channelSlug={channelSlug} />;
  }

  return <ReachCampaignPage />;
}

export function EditCampaign() {
  return (
    <EditCampaignProvider>
      <EditCampaignContent />
    </EditCampaignProvider>
  );
}
